/* src/store/modules/settings.js */
//import variables from '@/styles/element-variables.scss'
const state = {
	theme:{
		themecolor:1,
		theme:'#409EFF',
		menuLayout:0,//菜单0左菜单1顶菜单2混合菜单
		isCollapse:0,
		viewTag:1,
		viewFooter:0
	}	
}
const mutations = {
	CHANGE_SETTING: (state, data) => {		// 缓存起来，刷新的时候重新取用//
		state.theme = data
		console.log(state.theme)
		localStorage.setItem('theme',JSON.stringify(data)); 
	},
}
const actions = {
	changeSetting({commit}, data) {
		commit('CHANGE_SETTING', data)
	},	
}
export default {
	namespaced: true,
	state,
	mutations,
	actions
}